import PropTypes from "prop-types";
import classNames from 'classnames';

import {Disclosure} from "@headlessui/react";
import AnimateHeight from 'react-animate-height';
import ChevronIcon from '@autocx/icons/src/chevron-icon';

import Fields from "./fields";

	const CollapseExpandButton = function (props) {
	    if (props.canExpand) {
	        const hasSummary = Boolean(props.fieldset.summary);
	        return (
	            <Disclosure.Button
	                as={"div"}
	                data-accordion-trigger={props.fieldset.id || props.fieldset.label}
	                className={classNames("w-full flex justify-between items-center group cursor-pointer")}> 
	                <div>
	                    {props.fieldset.label ? (
                        <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                            {props.fieldset.icon ? <props.fieldset.icon className="w-5 h-5 text-gray-900 shrink-0" aria-hidden="true"/> : null}
                            <h3 className="text-lg leading-6 font-medium text-gray-900 group-hover:text-link shrink-0">{props.fieldset.label}</h3>
                            {hasSummary ? (
                                <AnimateHeight
                                    duration={200}
                                    height={props.open ? 0 : 'auto'}
                                    animateOpacity={true}
                                    className="min-w-0">
                                    <div className="flex flex-wrap items-center gap-1 min-w-0">
                                        {(Array.isArray(props.fieldset.summary) ? props.fieldset.summary : [props.fieldset.summary]).map((summaryItem, index) => (
                                            <span
                                                key={`${props.fieldset.id || props.fieldset.label}-summary-${index}`}
                                                className="max-w-full whitespace-normal rounded-full bg-slate-100/90 px-2.5 py-0.5 text-xs leading-4 text-slate-700">
                                                                                                {summaryItem}
                                            </span>
                                        ))}
                                    </div>
                                </AnimateHeight>
                            ) : null}
                        </div>
                    ): null}
	                    {props.children}
	                </div>
	                <div className={"group-hover:text-link"}>
                    <span className={classNames("border-current h-6 w-6", props.open ? "chevron--up" : "chevron--down")}>
                        <ChevronIcon />
                    </span>
                </div>
            </Disclosure.Button>
        );
    } else {
        return (
            <>
                {props.fieldset.label ? (
                    <div className="flex items-center space-x-2">
                        {props.fieldset.icon ? <props.fieldset.icon className="w-5 h-5 text-gray-900" aria-hidden="true"/> : null}
                        <h3 className="text-lg leading-6 font-medium text-gray-900 group-hover:text-link">{props.fieldset.label}</h3>
                    </div>
                ): null}
                {props.children}
            </>
        );
    }
}

SimpleStackedLayout.propTypes = {
    fieldset: PropTypes.object.isRequired,
    onFieldChange: PropTypes.func,
    onEditFieldsetSettings: PropTypes.func,
}

SimpleStackedLayout.defaultProps = {
    fieldsets: {},
    onFieldChange: () => {},
}

export default function SimpleStackedLayout({children, editButton, ...props}) {
    const canExpand = props.fieldset.collapsable === true && !props.fieldset.childrenOnly;
    return (
        <Disclosure
            as={"div"}
            key={`fieldset-${props.fieldset.id || props.fieldset.label}-${props.fieldset.expanded ? 'open' : 'closed'}`}
            defaultOpen={!(props.fieldset.collapsable === true) || props.fieldset.expanded === true}
            className={props.fieldset.className}
            data-anchor={props.fieldset.anchor || props.fieldset.id || props.fieldset.label}
            id={props.fieldset.id ? `fieldset-${props.fieldset.id}` : undefined}
        >
            {({ open }) => (
                <>
                    <CollapseExpandButton {...props} open={open} canExpand={canExpand}>
                        {editButton}
                    </CollapseExpandButton>
                    {canExpand ? (
                        <AnimateHeight
                            height={open ? 'auto' : 0}
                            animateOpacity={true}
                        >
                            <Disclosure.Panel static data-accordion-panel>
                                {!props.fieldset.childrenOnly && props.fieldset.description ? (
                                    <p className="mb-3 text-sm text-gray-500">{props.fieldset.description}</p>
                                ) : null}
                                <Fields {...props} className={"cx-fieldset-body space-y-4 mt-2 mb-5"}>
                                    {children}
                                </Fields>
                            </Disclosure.Panel> 
                        </AnimateHeight>
                    ): (
                        <>
                            {!props.fieldset.childrenOnly && props.fieldset.description ? (
                                <p className="mb-3 text-sm text-gray-500">{props.fieldset.description}</p>
                            ) : null}
                            <Fields {...props} className={"cx-fieldset-body space-y-4 pt-2 pb-5"}>
                                {children}
                            </Fields>
                        </>
                    )}
                </>
            )}
        </Disclosure>
    )
};

SimpleStackedLayout.EditButton = function (props) {
    return (<a className={"display-block"} href="forms/src/layouts/simple-stacked-layout#" onClick={props.onClick}>{props.children}</a>)
};
